/**
 * 数据管理化仓库
 * 不管是 大型应用网页还是 小型 应用网页 一律推荐如下方式进行数据管理开发
 * app.js => 管理 可管理 你在全局存入的任何数据 token
 * keeAalive.js => 管理 router中需要缓存页面
 * settings.js => 管理 可管理 你在全局设置的任何基本设置
 * permissions.js => 管理 用户信息 以及用户权限
 * 
 * mutations 同步 变量名 建议 大写 加 底横杠
 * actions   异步 变量名 正常小驼峰
 * createPersistedState 将 vuex存储与localStorage
 * 
 * state 访问
 * this.$store.state.XXXX 在modules模块化后 this.$store.state.modules名.XXXX
 * 如: this.$store.state.app.XXXX
 * store.state.app.XXXX
 * ...mapState({
      XXXX: state => state.app.XXXX,
   })
   ...mapState("modules名",{
      名字:属性名字
   })
 * 
 * mutations 访问
 * this.$store.commit('XXXX') 在modules模块化后 this.$store.commit('modules名/XXXX')
 *...mapMutations([
      'increment',
    ])
  ...mapMutations(["模块名字/方法"])
  ...mapMutations({
    方法:(state)=>state.模块名.方法, //模块方法
    方法:(state)=>state.方法		//全局方法
  })
 *
 * actions 访问
 * this.$store.dispatch('XXXX') 在modules模块化后 this.$store.dispatch('modules名/XXXX')
 * ...mapActions([
      'increment',
   ]),
 * ...mapActions(["模块名字/方法名"])
	 ...mapActions({
      方法:(state)=>state.模块名.方法, //模块方法
      方法:(state)=>state.方法		//全局方法
   })
 * 
 * getters 访问
 * store.getters.XXXX   this.$store.getters.XXXX
 * ...mapGetters([
    'XXXX',
    // ...
  ])
 * 
 */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import getters from './getters.js'
Vue.use(Vuex);
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
  }, {})
const store = new Vuex.Store({
    modules,
    getters,
    plugins: [createPersistedState()]
});
export default store;